<div class="container">
    <nb-accordion class="accordion-card">
        <nb-accordion-item expanded>
            <nb-accordion-item-header>
                <h1 class="paragraph">DETEKTO MASHTRIMIN</h1>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
                <div class="d-flex">
                    <p class="short-paragraph">
                        Në këtë uebfaqe, janë paraqitur skenaret e ndryshëm për zbulimin e mashtrimit në mënyrë që përdoruesi të ekzaminoj këto të dhëna. Ndikimi i inxhierisë, përzgjedhja e veçorive dhe nxjerrja e parametrave për hulumtim janë konsideruar me qëllim të arritjes
                        së një performance parashikuese sa më të avancuar.
                    </p>
                    <img src="../../../../../assets/images/scenario.svg" />
                </div>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
    <nb-card class="white-card mt-5">
        <p class="paragraph mb-4">
            Aksidentet e përsëritura në periudhën 2 vjeçare
        </p>
        <p class="dark-paragraph">
            Sikurse skenari 1 edhe ky skenar i përket mashtrimit më të zakonshëm të aksidenteve të trafikut kur një automjet i dyshuar papritmas rrëshqet drejt e para makinës tjetër. Këto aksidente vijojn të përsëriten më shumë se një herë gjatë periudhës dy vjeçare.
            <br />
            <br /> Për të kontrolluar nëse aksidenti i plotëson kriteret dhe është rast potencial për mashtrim shkruani numrin personal të individit të përfshirë në aksident dhe evidentoni gjendjen. <br />
            <br /> Nëse numri personal i individit është potencial mashtrimi, rekomandohet të kontrollohet edhe evidenca e gjendjes nga skenari 3 si më poshtë.
        </p>
    </nb-card>
    <div class="search mb-4">
        <form class="form" #nameForm="ngForm" novalidate (ngSubmit)="saveNameForm(personalId)">
            <input [(ngModel)]="personalId" name="id" #id="ngModel" placeholder="Kërko numrin personal…" nbInput aria-describedby="idHelp" minlength="10" maxlength="10" />
            <button id="button" type="submit" class="blue-button ml-2" routerLink="/scenario-two-results/{{ personalId }}" [disabled]="id.invalid">
				KËRKO
			</button>
        </form>
        <span id="button" class="text-danger ml-2 mt-4" *ngIf="id && id.invalid && id.touched">Ju lutem shkruani numrin përsonal për të vazhduar</span
		>
	</div>
</div>